export default __webpack_public_path__ + "static/users-section-image-d20b06f4af6c9eeb51e20f5758a43efe.png";